const headerId = 'main-site-header';
const headerStickyClass = 'header--sticky';
const burgerButtonClass = 'burger';
const burgerOpenButtonClass = 'burger--active';
const burgerOpenHeaderClass = 'header--burger-open';
const headerBackdropClass = 'header__backdrop';

const header = document.getElementById(headerId);
const burgerButtonEl = header?.querySelector(`.${burgerButtonClass}`);
const headerBackdropEl = header?.querySelector(`.${headerBackdropClass}`);

function burgerButtonHandle() {
  const isBurgerOpen = header?.classList.contains(burgerOpenHeaderClass);
  header?.classList.toggle(burgerOpenHeaderClass, isBurgerOpen);
  burgerButtonEl?.classList.toggle(burgerOpenButtonClass, isBurgerOpen);
}

function makeHeaderSticky() {
  const scrollTip = window.scrollY > 150;
  header?.classList.toggle(headerStickyClass, scrollTip);
}

function closeSidebar() {
  header?.classList.remove(burgerOpenHeaderClass);
  burgerButtonEl?.classList.remove(burgerOpenButtonClass);
}

function initialize() {
  burgerButtonHandle();
  window.addEventListener('scroll', makeHeaderSticky);
  headerBackdropEl?.addEventListener('click', closeSidebar);
}

export default {
  initialize,
};
